export var getIdFromToken = function (token) {
    return token.replace('[', '')
        .replace(']', '')
        .split('|')[1];
};
